<script lang="ts">
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'
import { useBaseInfoStore } from '@/store/baseInfo' // 引入uni-app-js
import { checkOpenid, saveOpenid } from '@/service/app/person'
import { useUserStore } from '@/store'
import { useI18n } from 'vue-i18n'
import { useI18nSync } from '@/hooks/useI18nSync'
import { getOpenidByCode } from '@/service/app/featured'

import Cookies from 'js-cookie'
import { ensureH5DeviceId } from '@/utils/deviceId'



import nAppsensors from '@/common/uni-app-sdk-0.1.6/index'

import { v4 as uuidv4 } from 'uuid'

// 生成sessionId
const generateMixedUUID = () => {
  const uuid = uuidv4()
  const digits = uuid.replace(/[^0-9]/g, '')
  const lowercase = uuid.replace(/[^a-z]/g, '')
  return digits + lowercase // 拼接
}

function generateMixedWXUUID() {
  const hexString = Math.random().toString(16).substring(2)
  const fullHexString = hexString.padStart(16, '0')
  const digits = fullHexString.replace(/[^0-9]/g, '')
  const lowercase = fullHexString.replace(/[^a-z]/g, '')
  return digits + lowercase // 拼接
}

const defaultSessionId =




generateMixedUUID()


const currentSessionId = useStorage('currentSessionId', defaultSessionId)

let sensors = null


sensors = nAppsensors







const sensorsConfig = {
  // 接收地址为clklog-receiver 的接收服务地址，project和token参数必须传入，token是每个project对应的随机字符串，请自行随机生成。
  server_url: import.meta.env.VITE_CLKLOG_URL,
  show_log: true, // 是否开启日志
  name: 'sensors',
  global_properties: {
    $event_session_id: currentSessionId.value,
  },
  autoTrack: {
    // 小程序全埋点配置
    appLaunch: true, // 默认为 true，false 则关闭 $MPLaunch 事件采集
    appShow: true, // 默认为 true，false 则关闭 $MPShow 事件采集
    appHide: true, // 默认为 true，false 则关闭 $MPHide 事件采集
    pageShow: true, // 默认为 true，false 则关闭 $MPViewScreen 事件采集    ----------
    pageShare: true, // 默认为 true，false 则关闭 $MPShare 事件采集
    mpClick: true, // 默认为 false，true 则开启 $MPClick 事件采集， VUE3 不支持
    mpFavorite: true, // 默认为 true，false 则关闭 $MPAddFavorites 事件采集
    pageLeave: true, // 默认为 false， true 则开启 $MPPageLeave事件采集
  },
  is_track_single_page: true,
  heatmap: {
    clickmap: 'default',
    scroll_notice_map: 'default',
    collect_tags: {
      img: true,
      video: true,
      button: true,
      'uni-view': true,
      // 'uni-view': true,
      'uni-button': true,
    },
  },
  preset_properties: { latest_referrer_host: true },
  app: {
    // Android & iOS 初始化配置
    remote_config_url: '',
    flush_interval: 5000, // 两次数据发送的最小时间间隔，单位毫秒
    flush_bulkSize: 100, // 设置本地缓存日志的最大条目数，最小 50 条， 默认 100 条
    flush_network_policy: 30, // 设置 flush 时网络发送策略
    auto_track: 3, // 1 应用启动， 2 应用退出，3 应用启动和退出 默认 0
    encrypt: false, // 是否开启加密
    add_channel_callback_event: false, // 是否开启渠道事件
    javascript_bridge: false, // WebView 打通功能
    android: {
      // Android 特有配置
      session_interval_time: 30000,
      request_network: true,
      max_cache_size: 32, // 默认 32MB，最小 16MB
      mp_process_flush: false, // 使用小程序 SDK 时，小程序进程是否可发送数据
    },
    ios: {
      // iOS 特有配置
      max_cache_size: 10000, // 最大缓存条目数，默认 10000 条
    },
  },
}


sensors.init(sensorsConfig)






let pageViewEventName = '$pageview'









let network = 'none'
const networkStatusChange = (res: any) => {
  if (res.networkType !== 'none' && network === 'none') {
    uni.reLaunch({
      url: '/pages/index/index',
    })
  }
  network = res.networkType
}







































export default {
  globalData: {
    sensors,
    pageViewEventName,
    // 是否进入注销审核
    isEnterAccountDeletionReview: false,
    // 审核信息
    accountDeletionAuditInfo: {
      // cancellation_at: '2025-10-10 12:00:00',
      // period_days: '7',
    },
    /** 精选页群 id（进程内存，杀进程/退出小程序后自动清空，不走 storage） */
    featuredRoomId: '',
  },

  onLaunch: () => {

    // 检查是否有 ssoInfo UMC登录态存在，存在则直接设置token
    const userStore = useUserStore()
    if (Cookies.get('ssoInfo')) {
      const ssoInfo = JSON.parse(Cookies.get('ssoInfo') || '{}')
      userStore.setToken(ssoInfo.access_token)
    }
    // H5 生成/复用本地设备 id，供未登录场景替代 openid
    ensureH5DeviceId()

    const { setLocale } = useI18nSync()
    const systemInfo = uni.getSystemInfoSync()
    console.log('系统语言:', systemInfo.language)
    console.log('系统信息:', systemInfo)

    const href = window.location.href
    const index1 = href.indexOf('#')
    const index2 = href.indexOf('?')
    if (index1 > -1 && index2 > -1 && index1 > index2) {
      const searchParams = new URLSearchParams(window.location.search).toString()
      const hashPath = `#/${window.location.pathname}` // uni-app 的 Hash 路由需要保留 #

      // 跳转（注意：此方法会刷新页面）
      window.location.href = `${window.location.origin}/${hashPath}?${searchParams}`
    }

    const storedLang = uni.getStorageSync('currentLang')
    console.log('storedLang====', storedLang)
    const systemLang =
      systemInfo?.language === 'zh-CN' || systemInfo?.language === 'zh-Hans-CN' ? 'zh-Hans' : 'en'
    // setLocale(storedLang || systemLang)
    setLocale('zh-Hans')
  },
  onShow: () => {
    const { t } = useI18n()

































    uni.getNetworkType({
      success: (res) => {
        network = res.networkType
      },
    })
    uni.onNetworkStatusChange(networkStatusChange)
  },

  onHide: () => {
    uni.offNetworkStatusChange(networkStatusChange)

    // 重新进入小程序需要重置
    const baseInfoStore = useBaseInfoStore()
    baseInfoStore.currentArea = {
      id: '',
      logo: '',
      name: '',
    }
    baseInfoStore.currentSort = {
      sort_field: undefined,
      sort_mode: undefined,
    }
  },

  methods: {},
}
</script>
<style lang="scss">
/* stylelint-disable selector-type-no-unknown */

button::after {
  border: none;
}

#aliyunCaptcha-mask {
  z-index: 500 !important;
}
#aliyunCaptcha-window-embed,
#aliyunCaptcha-window-popup {
  z-index: 501 !important;
}

swiper,
scroll-view {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

image {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}
:deep(.uni-scroll-view) {
  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
  }
}
</style>
